import React, { Component, createRef } from "react";
import platform from "Pub/js/platform";
import { langCheck } from "Pub/js/utils.js";
import { handleHotKey } from "./methods";
const { NCModal, NCButton, NCTooltip } = platform.base;
/* 
    快捷键NC弹窗（参数是antd与NCModal参数混用），为了与平台Modal交互一致，替换成NCModal
    由于NCModal不支持onOk/onCancel，如果需要确定取消的快捷键，需要传onOk和onCancel
 */
class HotKeyNCModal extends Component {
    constructor(props) {
        super(props);
        this.ncModal = createRef();
    }
    componentDidMount() {
        document.addEventListener("keydown", this.handleBindKey, false);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleBindKey, false);
    }
    handleBindKey = (event) => {
        handleHotKey.call(this, event, this.ncModal);
    };
    //将antd Modal的参数转换成NCModal的参数，目的为了兼容旧代码
    mapAntdPropsToNcProps = () => {
        let newProps = { ...this.props };
        //antd Modal参数与NCModal参数的映射
        const mapProps = {
            visible: "show", //显示modal
            customHeader: "NCTitle", //标题
            title: "NCTitle", //标题
            closable: "closeButton", //是否显示关闭按钮
            // wrapClassName: "className", //模态框外层容器的类名
            // className: "dialogClassName", //模态框的类名
            mask: "backdrop", //是否显示遮罩
            maskClosable: "backdropClosable", //点击遮罩是否关闭模态框
            maskStyle: "backdropStyle", //遮罩样式
            onCancel: "onHide", //关闭时的钩子函数
        };
        for (const [antdProps, ncProps] of Object.entries(mapProps)) {
            if (antdProps in this.props) {
                newProps[ncProps] = this.props[antdProps];
            }
            if (antdProps !== "className") {
                delete newProps[antdProps];
            }
        }
        //antd的关闭按钮默认显示，与NCModal默认值相反
        if (this.props.closable === undefined) {
            newProps.closeButton = true;
        }
        return newProps;
    };

    render() {
        //默认参数
        const defaultProps = {
            draggable: true, //是否可拖拽
            resizable: true, //是否可resize
        };
        let mapProps = this.mapAntdPropsToNcProps();
        const newProps = { ...defaultProps, ...mapProps };
        const {
            closeButton,
            NCTitle,
            onHide, //NCModal参数
            okText,
            cancelText,
            onOk, //antd参数
        } = newProps;
        const OkBtn = (<NCTooltip
            placement="top"
            overlay={`${okText || langCheck('0000PUB-000001')}(Alt + Y)`}
        >
            <NCButton key="submit" colors="primary" onClick={onOk} fieldid="ok">
                {okText || langCheck('0000PUB-000001')}(<span className="underline">Y</span>)
                {/* /* 国际化处理： 确定*/}
            </NCButton>
        </NCTooltip>
        );
        const CancelBtn = < NCTooltip
            placement="top"
            overlay={`${cancelText || langCheck('0000PUB-000000')}(Alt + N)`
            }
        >
            <NCButton key="back" onClick={onHide} fieldid="cancel">
                {cancelText || langCheck('0000PUB-000000')}(<span className="underline">N</span>)
                {/* /* 国际化处理： 取消*/}
            </NCButton>
        </NCTooltip >
        const { footer } = this.props;
        const renderPropFooter = () => {
            if (typeof footer === "function") {
                return footer({ OkBtn, CancelBtn });
            } else {
                return footer;
            }
        };
        const newFooter = footer ? (
            renderPropFooter()
        ) : footer === null ? null : (
            <React.Fragment>
                {OkBtn}
                {CancelBtn}
            </React.Fragment>
        )
        return (
            <NCModal fieldid={this.props.fieldid} {...newProps} ref={this.ncModal} footer={newFooter}>
                <NCModal.Header closeButton={closeButton}>
                    <NCModal.Title fieldid={this.props.titleFieldid || this.props.fieldid}>
                        {NCTitle}
                        {this.props.customTitle}
                    </NCModal.Title>
                    {this.props.header}
                </NCModal.Header>
                <NCModal.Body>{this.props.children}</NCModal.Body>
            </NCModal >
        );
    }
}
export default HotKeyNCModal;
